export default __webpack_public_path__ + "static/media/awaitingQuotes.931abf70.svg";